import React from 'react';

import { formatDateTimeLong } from '@neptune/shared/common-util';
import { Layout, Text } from '@neptune/shared/venus-ui';

type ServiceAccountCreatedByProps = {
  createdBy: string;
  createdDate: Date;
  userComponent: React.FC<{ user: string }>;
};

export const ServiceAccountCreatedBy: React.FC<ServiceAccountCreatedByProps> = ({
  createdBy,
  createdDate,
  userComponent: UserWithAvatar,
}) => {
  return (
    <Text size="sm">
      <Layout.Row spacedChildren="xs" wrap="wrap">
        <Text>Created {formatDateTimeLong(createdDate)} by </Text>
        <UserWithAvatar user={createdBy} />
      </Layout.Row>
    </Text>
  );
};
